import { differenceInDays } from 'date-fns';

import { HotelSearched } from '@hotels/hotel-results/entities/hotel-searched';
import { ProductProperties } from '@avo/interface/trigger-props';
import { HotelReservation } from '@booking/entities/hotel-validation.response';
import { HotelInfoDetail } from '@hotels/hotel-detail/entities/hotel-detail.response';
import { isNullOrUndefined } from '@app/util/util';

export function hotelAmplitudeProductPropertiesMapper(
  result: HotelSearched, 
  info: HotelInfoDetail,
  packHour: number,
  roomCode: string | null = null
): ProductProperties {
  if (!result) return {};
  const checkin = new Date(result.CheckinDate);
  const checkout = new Date(result.CheckoutDate);
  const days = differenceInDays(checkout, checkin);
  const roomRate = result.RoomRates.find(x => x.Rooms.filter(y => y.RoomCode === roomCode).length > 0);
  const isByhours = result.MicroStay;
  const price = roomRate?.Price.Total || 0;
  const pricePerDay = price / days;
  const pricePerHours = price / packHour;
  const props = {
    TRAVEL_PRODUCT_CODE: info.HotelCode,
    TRAVEL_PRODUCT_NAME: info.HotelName,
    TRAVEL_PRODUCT_CATEGORY: info.Category.toString(),
    TRAVEL_PRODUCT_PRICE: isByhours ? pricePerHours : pricePerDay,
    TRAVEL_PRODUCT_PROVIDER: result.HotelProvider,
    TRAVEL_TOTAL_PRICE: price
  };
  const hasHotelMemberRate = roomCode ? roomRate?.MemberRateIndicator :
    result?.RoomRates?.some(rate => !!rate.MemberRateIndicator);
  return { 
    ...props,
    ...(!isNullOrUndefined(hasHotelMemberRate)) && { TRAVEL_HAS_MEMBER_RATE: !!hasHotelMemberRate }
  };
}

export function hotelAmplitudeProductPropertiesMapperFromValidation(data: HotelReservation): ProductProperties {
  if (!data) return {};
  const checkin = new Date(data.Checkin);
  const checkout = new Date(data.Checkout);
  const days = differenceInDays(checkout, checkin);
  const isByhours = data.MicroStay;
  const pricePerDay = data.Price.Total / days;
  const pricePerHours = data.Price.Total / data.Rooms?.[0].PackHour;
  return {
    TRAVEL_PRODUCT_CODE: data.Hotel.HotelCode,
    TRAVEL_PRODUCT_NAME: data.Hotel.HotelName,
    TRAVEL_PRODUCT_CATEGORY: data.Hotel.Category.toString(),
    TRAVEL_PRODUCT_PRICE: isByhours ? pricePerHours : pricePerDay,
    TRAVEL_TOTAL_PRICE: data?.Price?.Total
  };
}
